// Firebase configuration - lazy initialization for performance
// Firebase SDK wordt pas geladen wanneer nodig (bespaart ~90-150 KiB op initial bundle)
import type { Auth } from 'firebase/auth';
import type { Firestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDXlabB2cVGTcYGNt6WZqW4Nix9obIlpTA",
  authDomain: "wft-tool.firebaseapp.com",
  projectId: "wft-tool",
  storageBucket: "wft-tool.firebasestorage.app",
  messagingSenderId: "522866651065",
  appId: "1:522866651065:web:a5124173c436aaae175068",
  measurementId: "G-GH058CTYF1"
};

// Mutable exports - populated after async initialization
// Uses ES module live bindings: consumers always read the current value
export let auth: Auth = null as unknown as Auth;
export let db: Firestore = null as unknown as Firestore;
export let googleProvider: any = null;

// Initialize Firebase asynchronously - SDK code goes in separate webpack chunks
export const firebaseReady: Promise<void> = (async () => {
  const [
    { initializeApp },
    { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence },
    { getFirestore }
  ] = await Promise.all([
    import('firebase/app'),
    import('firebase/auth'),
    import('firebase/firestore')
  ]);

  const app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  googleProvider = new GoogleAuthProvider();

  // Set auth persistence to LOCAL (blijft ingelogd na browser refresh/redirect)
  await setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.error('Error setting auth persistence:', error);
  });
})();
